import { FolderOpen, SearchX } from 'lucide-react';

interface FolderPickerEmptyProps {
  searchQuery: string;
}

export function FolderPickerEmpty({ searchQuery }: FolderPickerEmptyProps) {
  const isSearch = searchQuery.trim().length > 0;

  return (
    <div className="flex flex-col items-center justify-center gap-2 py-10 text-muted-foreground">
      {isSearch ? (
        <>
          <SearchX className="h-8 w-8" />
          <p className="text-sm">No folders matching &ldquo;{searchQuery}&rdquo;</p>
        </>
      ) : (
        <>
          <FolderOpen className="h-8 w-8" />
          <p className="text-sm">No folders here</p>
        </>
      )}
    </div>
  );
}
